// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es6:true*/
(function(){
const is_node = typeof module=='object' && module.exports;
const define = !is_node ? self.define
    : require('../../../../util/require_node.js').define(module, '..');
// note to all: react must *not* be added to dependencies
define(['/util/ajax.js', 'lodash4'],
    (ajax, _)=>{
const E = {};
const {assign} = Object;
// ga script may be blocked by adblockers
if (!is_node)
    window.ga = _.isFunction(window.ga) ? window.ga : function(){};

E.ga_event = (cat, action, label, value)=>{
    window.ga('send', 'event', cat, action, label, value);
};

E.ga_virtual_pw = (...params)=>{
    let pw = '/_/' + params.filter(a=>a!=undefined).join('/');
    window.ga('send', 'pageview', pw);
};

E.gtm_event = (event, opt)=>{
    if (!window.dataLayer)
        return;
    window.dataLayer.push(assign({event}, opt));
};

E.gtm_ga_event = (ga_category, ga_action, ga_label)=>{
    E.gtm_event('ga_event', {ga_category, ga_action, ga_label});
};

E.onboarding_event = (action_num, _label, meta={})=>{
    const {prefix=''} = meta;
    ajax({url: prefix+'/onboarding_counter', method: 'POST',
        data: {code: action_num-1}});
};

// XXX bruno: move other google analytics util functions to this file

return E; }); })(); // eslint-disable-line
